import React from "react";
import ReactDom from "react-dom";
import VoucherModal from "shared/components/VoucherModal";

const Voucher = {
	init(shouldOpen = false) {
		if (!this.voucherNode) {
			this.voucherNode = document.createElement("div");
			document.body.appendChild(this.voucherNode);
		}

		if (shouldOpen) {
			this.open();
		}
	},

	close() {
		requestAnimationFrame(() => {
			ReactDom.unmountComponentAtNode(this.voucherNode);
		});
	},

	open() {
		if (!this.voucherNode) {
			this.init(true);
			return;
		}

		ReactDom.render(<VoucherModal />, this.voucherNode);
	},
};

window.Voucher = Voucher;

export default Voucher;



// WEBPACK FOOTER //
// ./src/features/vouchers/index.js